import React from 'react'

const Register = () => {
  return (
    <h1>Register</h1>
  );
}

export default Register;